module.exports = __webpack_public_path__ + "img/logo_new.5b951b82.svg";